(function () { 
    if (window.AOS) {
     AOS.init({
          once: true,
          offset: 200,
       });
    }  
})();
